import { render } from "./InputPayment.vue?vue&type=template&id=0ab1b84e&scoped=true"
import script from "./InputPayment.vue?vue&type=script&lang=js"
export * from "./InputPayment.vue?vue&type=script&lang=js"

import "./InputPayment.vue?vue&type=style&index=0&id=0ab1b84e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0ab1b84e"

export default script